// Logo per masseleverandør: validering av opplastet fil og lenke, og lagringssti.
export const MAX_LOGO_BYTES = 2 * 1024 * 1024;
export const LOGO_TYPES = ['image/png', 'image/jpeg', 'image/svg+xml', 'image/webp'];

export function validateLogoFile(file) {
  if (!file) return 'Velg en fil';
  if (!LOGO_TYPES.includes(file.type)) return 'Logoen må være PNG, JPG, SVG eller WebP';
  if (file.size > MAX_LOGO_BYTES) return 'Logoen kan være maks 2 MB';
  return null;
}

// Tom lenke betyr «ingen logo» og er gyldig.
export function validateLogoUrl(url) {
  const value = String(url ?? '').trim();
  if (!value) return null;
  try {
    return new URL(value).protocol === 'https:' ? null : 'Lenken må starte med https://';
  } catch {
    return 'Ugyldig lenke';
  }
}

export function logoPath(supplierId, file, now = Date.now()) {
  const dot = String(file?.name ?? '').lastIndexOf('.');
  const ext = dot >= 0 ? file.name.slice(dot + 1).toLowerCase() : 'png';
  return `supplierLogos/${supplierId || 'ny'}/${now}.${ext || 'png'}`;
}
